import { render, staticRenderFns } from "./RptIntradisciplinaryProfile.vue?vue&type=template&id=333d0392&scoped=true&"
import script from "./RptIntradisciplinaryProfile.vue?vue&type=script&lang=js&"
export * from "./RptIntradisciplinaryProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d0392",
  null
  
)

export default component.exports